<template>
  <div class="login_wrap">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "adminLoginLayout",
  created(){ console.log("@@@@@ adminLoginLayout")}
};
</script>